import { createContext, useRef, useState } from 'react';

export const NetspendContext = createContext({});

export default function NetspendProvider({ children }) {
	const [toastData, setToastData] = useState([]);
	const [stripeHeight, setStripeHeight] = useState(null);
	const carouselLotties = useRef({});

	return (
		<NetspendContext.Provider
			value={{
				toastData,
				setToastData,
				stripeHeight,
				setStripeHeight,
        carouselLotties
			}}>
			{children}
		</NetspendContext.Provider>
	);
}
